/* global ga */
const id = `Bespoke - ${process.env.REACT_APP_TRACK_ID}`;
export function track(action, label) {
	if (process.env.NODE_ENV === 'production') ga('send', 'event', id, action, label );
	else console.log( `id: ${id} - action: ${action}, label: ${label}` );
}
